import Polyline from '@arcgis/core/geometry/Polyline';
import Graphic from '@arcgis/core/Graphic';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import * as turf from '@turf/turf';

import { FsMap } from '@lib/geo/map';

import { FsShapeStyles } from '../helpers';
import { ShapeStylesType } from '../types';
import { FsMapShape } from './shapes';

export class FsMapPolyline extends FsMapShape {
  public shapeType = 'polyline';
  constructor(public shape?: any) {
    super({
      shape,
    });
  }

  public createPolyline(paths: number[][][], style: ShapeStylesType, map: FsMap): FsMapPolyline {
    switch (this.defaultMapSource) {
      case 'google':
        const path = paths.map((position: any) => {
          return new google.maps.LatLng({
            lat: position[1],
            lng: position[0],
          });
        });
        this.shape = new google.maps.Polyline({
          path,
          ...style,
        });

        this.map = map;
        this.listenForGoogleShapeEvents();

        return this;
      case 'esri':
        const polyline = new Polyline({
          spatialReference: {
            wkid: 4326,
          },
          paths,
        });
        const styles: any = new FsShapeStyles({ ...style }).styles;
        const simpleLine = new SimpleLineSymbol(styles.outline);

        this.shape = new Graphic({
          attributes: {
            id: crypto.randomUUID(),
          },
          geometry: polyline,
          symbol: simpleLine,
        });

        this.map = map;
        this.setupEsriClickHandler();

        return this;
    }
  }

  public getGeometry(): any {
    return turf.geometry('LineString', this.getPath());
  }
}
